import { Link } from 'react-router-dom';
import { navItems, siteInfo } from '@/mocks/site';
import { topics } from '@/mocks/topics';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 border-t border-background-200 bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-fire-line text-xl" />
              </span>
              <span className="font-heading text-2xl tracking-wide text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">{siteInfo.slogan}</p>
            <p className="mt-3 text-sm leading-relaxed text-background-400">
              用热度排行、话题榜与速报快讯，帮你在信息洪流里快速找到今天值得围观的那口瓜。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider text-background-200">站内导航</h4>
            <ul className="mt-4 space-y-3">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider text-background-200">热门话题榜</h4>
            <ul className="mt-4 space-y-3">
              {topics.slice(0, 4).map((topic) => (
                <li key={topic.id}>
                  <Link
                    to={`/topics?topic=${topic.slug}`}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {topic.name}
                    <span className="ml-2 text-xs text-background-500">{topic.articleCount} 篇</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider text-background-200">联系与说明</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              线索投稿、内容纠错或合作沟通，欢迎随时来信。
            </p>
            <a
              href={`mailto:${siteInfo.email}`}
              rel="nofollow"
              className="mt-3 inline-flex items-center gap-2 text-sm text-accent-400 transition-colors hover:text-accent-300"
            >
              <i className="ri-mail-line text-base" />
              {siteInfo.email}
            </a>
            <p className="mt-4 text-xs leading-relaxed text-background-500">
              本站内容基于公开传播信息整理，涉及个人的描述均不代表对其私人生活的判断。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-900 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © {year} {siteInfo.name} · 内容仅供信息聚合与交流参考
          </p>
          <p className="text-xs text-background-500">榜单热度每 10 分钟更新一次</p>
        </div>
      </div>
    </footer>
  );
}